// extracted by mini-css-extract-plugin
export var timelineContainer = "timeline-module--timelineContainer--6iAjZ";
export var timeline0 = "timeline-module--timeline0--gI6ev";
export var timeline1 = "timeline-module--timeline1--joOqf";